import { render, staticRenderFns } from "./withdrawalTab.vue?vue&type=template&id=bd637ab4&scoped=true&"
import script from "./withdrawalTab.vue?vue&type=script&lang=js&"
export * from "./withdrawalTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd637ab4",
  null
  
)

export default component.exports